import { useTranslation } from "react-i18next"

export const FlowDirectionTooltipContent = () => {
  const { t } = useTranslation("common")

  return (
    <>
      <strong>{t("fields.flowDirection.value.import")}</strong>
      {" - "}
      {t("fields.flowDirection.tooltip.import")}
      <br />
      <strong>{t("fields.flowDirection.value.export")}</strong>
      {" - "}
      {t("fields.flowDirection.tooltip.export")}
    </>
  )
}
